import { useEffect, useRef } from "react"

export const useOnMountEffect = (callBack: () => void) => {
  const mounted = useRef(false)

  return useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      callBack?.()
    }
  }, [callBack])
}
